import axios from 'axios';
import { publicAPI } from 'services/api/apiUrl';

export const getOrder = orderWithSecret => {
  return axios({
    method: 'get',
    url: `${publicAPI}/order/${orderWithSecret}`,
  });
};
